import { render } from "./Yurtzeiten_Display_Render.vue?vue&type=template&id=fafff4f8&scoped=true"
import script from "./Yurtzeiten_Display_Render.vue?vue&type=script&lang=js"
export * from "./Yurtzeiten_Display_Render.vue?vue&type=script&lang=js"

import "./Yurtzeiten_Display_Render.vue?vue&type=style&index=0&id=fafff4f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fafff4f8"]])

export default __exports__